const getShortLanguage = code => {
  if (!code) return 'en';
  const [firstPart] = code.split('-');
  return firstPart;
};

export default getShortLanguage;
